import styled from 'styled-components';

export const FieldHolder = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
`;
